export default __webpack_public_path__ + "static/media/nestjs.6b64ab77.svg";